import React from 'react';

const SuccessMsg = ({title, po, pm, subtitle, faqs, btnHelp, helpLink}) => {
    const faqBlock = faqs.map((faq, i) => {
        return (
            <p key={`faq-${i}`} className="contact__faq">
                <a
                    href={faq.link}
                    arial-label="FAQ link"
                    target="_blank"
                    rel="noreferrer"
                >
                    {faq.q}
                </a>
            </p>
        );
    });

    const userType = localStorage.getItem('userType');

    return (
        <div className="contact__success">
            <h3>{title}</h3>
            {userType === 'frbo' && <p className="contact__body">{po}</p>}
            {userType === 'pm' && <p className="contact__body">{pm}</p>}

            <div>
                <h3>{subtitle}</h3>
                <div className="contact__faqs">{faqBlock}</div>
            </div>

            <a
                className="btn btn-primary"
                aria-label="help link"
                href={helpLink}
                target="_blank"
                rel="noreferrer"
                dangerouslySetInnerHTML={{__html: btnHelp}}
            />
        </div>
    );
};

export default SuccessMsg;
